var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4043 2.55993H13.9418V1.85107C13.9418 1.46274 13.627 1.14795 13.2387 1.14795C12.8503 1.14795 12.5355 1.46274 12.5355 1.85107V2.55993H5.6793V1.85107C5.6793 1.46274 5.36451 1.14795 4.97618 1.14795C4.58784 1.14795 4.27305 1.46274 4.27305 1.85107V2.55993H0.810547C0.422211 2.55993 0.107422 2.87475 0.107422 3.26305V17.0386C0.107422 17.4269 0.422211 17.7417 0.810547 17.7417H17.4043C17.7926 17.7417 18.1074 17.4269 18.1074 17.0386V3.26305C18.1074 2.87475 17.7926 2.55993 17.4043 2.55993ZM16.7012 16.3354H1.51367V3.96618H4.27305V4.67507C4.27305 5.06341 4.58784 5.3782 4.97618 5.3782C5.36451 5.3782 5.6793 5.06341 5.6793 4.67507V3.96618H12.5355V4.67507C12.5355 5.06341 12.8503 5.3782 13.2386 5.3782C13.627 5.3782 13.9418 5.06341 13.9418 4.67507V3.96618H16.7012V16.3354Z",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10742 9.65407C9.63166 9.65407 10.0566 9.22908 10.0566 8.70484C10.0566 8.1806 9.63166 7.75562 9.10742 7.75562C8.58318 7.75562 8.1582 8.1806 8.1582 8.70484C8.1582 9.22908 8.58318 9.65407 9.10742 9.65407Z",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10742 13.7852C9.63166 13.7852 10.0566 13.3602 10.0566 12.836C10.0566 12.3118 9.63166 11.8868 9.10742 11.8868C8.58318 11.8868 8.1582 12.3118 8.1582 12.836C8.1582 13.3602 8.58318 13.7852 9.10742 13.7852Z",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.97632 9.65407C5.50056 9.65407 5.92554 9.22908 5.92554 8.70484C5.92554 8.1806 5.50056 7.75562 4.97632 7.75562C4.45208 7.75562 4.0271 8.1806 4.0271 8.70484C4.0271 9.22908 4.45208 9.65407 4.97632 9.65407Z",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2385 9.65407C13.7628 9.65407 14.1877 9.22908 14.1877 8.70484C14.1877 8.1806 13.7628 7.75562 13.2385 7.75562C12.7143 7.75562 12.2893 8.1806 12.2893 8.70484C12.2893 9.22908 12.7143 9.65407 13.2385 9.65407Z",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.97632 13.7852C5.50056 13.7852 5.92554 13.3602 5.92554 12.836C5.92554 12.3118 5.50056 11.8868 4.97632 11.8868C4.45208 11.8868 4.0271 12.3118 4.0271 12.836C4.0271 13.3602 4.45208 13.7852 4.97632 13.7852Z",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2385 13.7852C13.7628 13.7852 14.1877 13.3602 14.1877 12.836C14.1877 12.3118 13.7628 11.8868 13.2385 11.8868C12.7143 11.8868 12.2893 12.3118 12.2893 12.836C12.2893 13.3602 12.7143 13.7852 13.2385 13.7852Z",
    fill: "#677C95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.107422 0.444824)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d2e6a8cb7e04e616a9a119de9a60ef59.svg";
export { ForwardRef as ReactComponent };